import React from "react";
import { formatMoney } from "utils";

const OpenCloseBalance = ({ type, sum }) => {
  return(
    <div className="row align-items-center border-bottom border-1">
      <div className="col-4 col-md-3 col-sm-4 py-3 text-end px-0">
        <div className="fs-xmd-smaller fst-italic">
          {formatMoney(sum)}
        </div>
      </div>
      <div className="col-8 col-md-9 col-sm-8 ps-2" align="left">
        <b className="fs-6">
          {type =="open" ? "Open Balance" : "Close Balance"}
        </b>
      </div>
    </div>
  )
}

export default OpenCloseBalance;
